(() => {
// Scrub animation ================================================ //
const $c8fe6ad741db8e1e$var$sections = gsap.utils.toArray("[scrub-wrapper]");
const $c8fe6ad741db8e1e$var$width = document.documentElement.clientWidth;
const $c8fe6ad741db8e1e$var$height = window.innerHeight;
const $c8fe6ad741db8e1e$var$mm = gsap.matchMedia();
// Image sequence play on scroll =====================================//
let $c8fe6ad741db8e1e$var$allImagesCount = 0;
let $c8fe6ad741db8e1e$var$totalCount = 0;
// Initialize for each section
function $c8fe6ad741db8e1e$var$initSections() {
    $c8fe6ad741db8e1e$var$sections.forEach(function(section) {
        const prefix = section.dataset.prefix || null;
        const suffix = section.dataset.suffix || null;
        const frames = section.dataset.framecount || 0;
        const canvas = section.querySelector("canvas");
        if (!canvas || !prefix || !suffix || !frames) return;
        const device = $c8fe6ad741db8e1e$var$width >= 768 ? "desktop" : "mobile";
        $c8fe6ad741db8e1e$var$allImagesCount += Number(frames);
        $c8fe6ad741db8e1e$var$totalCount += Number(frames);
        $c8fe6ad741db8e1e$var$initCanvas(section, canvas, prefix, suffix, frames, device);
    });
}
$c8fe6ad741db8e1e$var$mm.add("(min-width: 768px)", ()=>{
    // desktop
    $c8fe6ad741db8e1e$var$initSections();
});
$c8fe6ad741db8e1e$var$mm.add("(max-width: 767px)", ()=>{
    // mobile
    $c8fe6ad741db8e1e$var$initSections();
});
function $c8fe6ad741db8e1e$var$updateImageSequenceCount(file) {
    $c8fe6ad741db8e1e$var$allImagesCount--;
    var updatedPercent = 100 - Math.round($c8fe6ad741db8e1e$var$allImagesCount * 100 / $c8fe6ad741db8e1e$var$totalCount);
    if ($c8fe6ad741db8e1e$var$allImagesCount === 0) setTimeout(function() {
        lenis.resize();
    }, 500);
}
// Initialize animation on canvas for each section. This loads
// the image sequence and make sure to load the right image based
// on scroll position.
function $c8fe6ad741db8e1e$var$initCanvas(section, canvas, prefix, suffix, frames, device) {
    var context = canvas.getContext("2d");
    canvas.width = $c8fe6ad741db8e1e$var$width;
    canvas.height = $c8fe6ad741db8e1e$var$height;
    var frameCount = frames;
    var currentFrame = function(index) {
        return `${prefix}${device}/${(index + 1).toString().padStart(3, "0")}${suffix}`;
    };
    var images = [];
    // loads all images for this sequence and checks if we loaded everything
    // for this page.
    for(var i = 0; i < frameCount; i++){
        var img = new Image();
        var imgSrc = currentFrame(i);
        img.onload = function() {
            $c8fe6ad741db8e1e$var$updateImageSequenceCount(imgSrc);
            // console.log(allImagesCount, imgSrc, i);
            // if (allImagesCount === 0) {
            if ($c8fe6ad741db8e1e$var$allImagesCount === $c8fe6ad741db8e1e$var$totalCount - 1) $c8fe6ad741db8e1e$var$initCanvasAnimations(section, images, context, canvas);
        };
        img.onerror = function() {
            $c8fe6ad741db8e1e$var$updateImageSequenceCount(imgSrc);
        };
        img.src = imgSrc;
        images.push(img);
    }
}
function $c8fe6ad741db8e1e$var$initCanvasAnimations(section, images, context, canvas) {
    var sequence = {
        frame: 0
    };
    var blocks = section.querySelectorAll("[frames-play]");
    blocks.forEach(function(block) {
        var start = Number(block.dataset.start), end = Number(block.dataset.end), posStart = block.dataset.startPos || "top top", posEnd = block.dataset.endPos || "bottom bottom";
        var blockSequence = {
            frame: 0
        };
        // Initializes timeline for scroll animation.
        gsap.timeline({
            onUpdate: function() {
                $c8fe6ad741db8e1e$var$render(images, blockSequence, context, canvas);
            },
            scrollTrigger: {
                trigger: block,
                pin: false,
                scrub: 1,
                start: posStart,
                end: posEnd,
                markers: false
            }
        }).fromTo(blockSequence, {
            frame: start - 1
        }, {
            frame: end - 1,
            snap: "frame",
            ease: "none",
            duration: 1
        }, 0);
    });
    $c8fe6ad741db8e1e$var$render(images, sequence, context, canvas);
    window.addEventListener("resize", function() {
        canvas.width = document.documentElement.clientWidth;
        canvas.height = window.innerHeight;
        $c8fe6ad741db8e1e$var$render(images, sequence, context, canvas);
    });
}
// Makes sure that the canvas is responsive, and updates the current
// painted image depending on the scroll position.
function $c8fe6ad741db8e1e$var$render(images, sequence, context, canvas) {
    var img = images[sequence.frame];
    // console.log(sequence.frame);
    context.clearRect(0, 0, canvas.width, canvas.height);
    var loadedImageWidth = img.width;
    var loadedImageHeight = img.height;
    // get the scale
    // it is the min of the 2 ratios
    var scaleFactor = Math.max(canvas.width / img.width, canvas.height / img.height);
    // Finding the new width and height based on the scale factor
    var newWidth = img.width * scaleFactor;
    var newHeight = img.height * scaleFactor;
    //console.log(img.width, img.height, scaleFactor, newWidth, newHeight);
    // get the top left position of the image
    // in order to center the image within the canvas
    var x = canvas.width / 2 - newWidth / 2;
    var y = canvas.height / 2 - newHeight / 2;
    // When drawing the image, we have to scale down the image
    // width and height in order to fit within the canvas
    context.drawImage(img, x, y, newWidth, newHeight);
}

})();
//# sourceMappingURL=scrubImageSequence.js.map
